module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow-container"
  }, [_c('div', {
    staticClass: "bracket-left"
  }, [_c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group"
  }, [_c('polygon', {
    attrs: {
      "points": "0 24 6 24 6 22 2.08571429 22 2.08571429 2 6 2 6 0 0 0"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "bracket-right"
  }, [_c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group"
  }, [_c('polygon', {
    attrs: {
      "points": "30 24 36 24 36 0 30 0 30 2 34 2 34 22 30 22"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }, [(_vm.type === 'next') ? _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group"
  }, [_c('polygon', {
    attrs: {
      "points": "13 18 23 13 23 11 13 6 13 8 21 12.0218182 13 16"
    }
  })])])]) : (_vm.type === 'share') ? _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group share-icon"
  }, [_c('path', {
    attrs: {
      "d": "M16.9990234,18 L19,18 L19,13 L24,13 L24,11 L19,11 L19,6 L16.9990234,6 L16.9990234,11 L12,11 L12,13 L16.9990234,13 L16.9990234,18 Z"
    }
  })])])]) : _c('svg', {
    attrs: {
      "width": "36px",
      "height": "24px",
      "viewBox": "0 0 36 24"
    }
  }, [_c('g', {
    attrs: {
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    staticClass: "fill-group"
  }, [_c('path', {
    attrs: {
      "d": "M23,18 L13,13 L13,11 L23,6 L23,8 L15,12.0218182 L23,16 L23,18 Z"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d3d22798"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/arrow.vue
// module id = 669
// module chunks = 1